import TranslationNS from '@/utils/Constants/TranslationNS'

const LEADERBOARD = TranslationNS.LEADERBOARD

/**
 * Page tour of « Réclamations » (`complaints`): the score disputes athletes send from the ranking.
 * The card, its status chips, search and division filter, then the table and the drawer a row opens
 * (reply state, comment, links to the ranking and the planning).
 */
export const CLAIMS_TOUR = {
    id: 'claims',
    version: 1,
    paths: ['complaints'],
    steps: [
        {
            key: 'head',
            target: '[data-tour="page-head"]',
            placement: 'bottom',
            title: 'Score disputes',
            description: 'Athletes who disagree with a score send a claim from the ranking. You answer them here.',
        },
        {
            key: 'list',
            target: '[data-tour="sec-claims"]',
            block: ':scope > .org-sec-h',
            placement: 'bottom',
            title: 'All the claims',
            description: 'Every claim of the event, the newest first.',
        },
        {
            key: 'status',
            target: '[data-tour="claims-status"]',
            placement: 'bottom',
            title: 'Sort by status',
            description: 'Pending claims are waiting for your answer. Accepted and rejected ones are already settled.',
        },
        {
            key: 'search',
            target: '[data-tour="claims-search"]',
            placement: 'bottom',
            title: 'Find a claim',
            description: 'Search a participant or a score, or keep only one division. The count tells how many match.',
        },
        {
            key: 'table',
            target: '[data-tour="sec-claims"] .org-tbl',
            block: 'thead',
            placement: 'bottom',
            title: 'Answer a claim',
            description: 'Date, participant, score, the claim and its state. Click a row to open it:',
            entries: [
                { label: 'Reply', ns: LEADERBOARD, text: 'accept or reject; the athlete is told.' },
                {
                    label: 'Organizer comment',
                    ns: LEADERBOARD,
                    text: 'a short message to the athlete, 500 characters at most.',
                },
                {
                    label: 'Open in leaderboard',
                    ns: LEADERBOARD,
                    text: 'to correct the score itself: the reply never changes it.',
                },
                { label: 'See planning', ns: LEADERBOARD, text: 'the heats of this athlete, in a new tab.' },
            ],
        },
    ],
}

export default CLAIMS_TOUR
